import { theme } from '@stratumn/atomic';

import customTheme from './customTheme';
import glassElement from './glassElement';
import globalSize from './globalSize';
import mediaQueries from './mediaQueries';
import scrollbar from './scrollbar';

export default {
  ...theme,
  ...customTheme,
  globalSize,
  mediaQueries,
  scrollbar: scrollbar(theme),
  glassElement: glassElement()
};
